"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OPERATING_SYSTEMS = exports.DEVICES = exports.APPLICATIONS = exports.PRODUCTS = void 0;
/**
 * @const PRODUCTS
 */
exports.PRODUCTS = {
    ControlCenter: 'ControlCenter',
    NewsCenter: 'NewsCenter',
    DocCenter: 'DocCenter',
    WorkSpace: 'WorkSpace',
    LiveSend: 'LiveSend',
    MeetingSpace: 'MeetingSpace',
    LiveInsights: 'LiveInsights',
    // The predictive tabs in the embedded app
    Predictive: 'Predictive',
};
/**
 * @const APPLICATIONS
 */
exports.APPLICATIONS = {
    Web: 'Web',
    Outlook: 'Outlook',
    Dynamics: 'Dynamics',
    Oracle: 'Oracle',
    Sugar: 'SugarCRM',
    NetSuite: 'NetSuite',
    EmbeddedGeneric: 'EmbeddedGeneric',
    Gmail: 'Gmail',
    PowerPoint: 'PowerPoint',
    Word: 'Word',
    Salesforce: 'Salesforce',
    iOS: 'iOS',
    Android: 'Android',
    DesktopSync: 'DesktopSync',
    WindowsMetro: 'WindowsMetro', // the legacy tablet app that also works on PC
};
/**
 * @const DEVICES
 */
exports.DEVICES = {
    PC: 'PC',
    Phone: 'Phone',
    Tablet: 'Tablet',
};
/**
 * @const OPERATING_SYSTEMS
 */
exports.OPERATING_SYSTEMS = {
    Windows: 'Windows',
    OSx: 'OSx',
    iOS: 'iOS',
    Android: 'Android',
    Linux: 'Linux',
    unknown: 'unknown',
};
//# sourceMappingURL=enums.js.map